module.exports = __webpack_public_path__ + "static/media/skyway_helps_2.b7d5ef36.jpg";